/*
  When we call some API, we store the parameters here and marked it as called.
  So next time we call the same API, we check if the parameter is used before.
  If it is used or cached, no fetch then.
  Currently this is for calendar availability API
*/

const UNAVAILABLE_DATES = 'unavailableDates';
const DATE_RANGE_BOOKABLILITY = 'dateRangeBookability';
const AVAILABILITY_BULK = 'availability/bulk';

const cacheObject = {
  [UNAVAILABLE_DATES]: {},
  [DATE_RANGE_BOOKABLILITY]: {},
  [AVAILABILITY_BULK]: {},
};

export { UNAVAILABLE_DATES, DATE_RANGE_BOOKABLILITY, AVAILABILITY_BULK };

export function addCacheKey(url, keyObject, valueObject) {
  const keyStr = JSON.stringify(keyObject);
  cacheObject[url][keyStr] = valueObject || true;
}

export function isKeyExist(url, keyObject) {
  const keyStr = JSON.stringify(keyObject);
  const keys = Object.keys(cacheObject[url]);
  if (!keys.includes(keyStr)) {
    return false;
  }
  return cacheObject[url][keyStr];
}
